/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              Kosangas.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var kosan = kosan || {};

// Document ready
$(function () {
    templatePolyfill();

    // Only include Novicell functions that you use!
    novicell.responsive.init();
    //novicell.map.init();
    // novicell.adjustFigureImage.init();
    // novicell.lazyload.content();
    // novicell.lazyload.image();

    // Call new functions here like this:
    //Kosangas.slider.heroSlider($('.owl-carousel'));

    novicell.responsiveLazyloadImage.image();
    novicell.embed.loadEmbeds();
    kosan.searchNav.init();
    kosan.header.init();
    kosan.form.init();
    kosan.maps.init();
    kosan.tileboxes.init();
    kosan.co2calculator.init();
    svg4everybody(); // Fix SVG spritemap in IE/Edge
    
    gridFix('.content-two-columns');
    gridFix('.grid-jumbotronwidget');
    setTimeout(function() {
        kosan.accordion.init();
        triggerContact();
    }, 150);
    dynamicContent();
    //gridFix('.grid-newslettersignup');

    if (!$('.grid-jumbotron-header').length) {
        $('.breadcrumb').addClass('adjusted');
    }

    //radio buttons hide the business input field
    //$('input:radio[name=newsletter-type]').change(function () {
    //    if ($(this).val() == 'Privat') {
    //        //$(".input-business").hide();
    //        newsletterChange(false)
    //    }
    //    if ($(this).val() == 'Erhverv') {
    //        newsletterChange(true)
    //        //$(".input-business").show();
    //    }
    //});

    // Waiting for the DOM to load
    document.addEventListener("DOMContentLoaded", function () {

        // Select your overlay trigger
        var trigger = document.querySelector('#js-overlay-trigger');

        if(trigger) {
            trigger.addEventListener('click', function(e){
            e.preventDefault();
    
            novicell.overlay.create({
                    'selector': trigger.getAttribute('data-element'),
                    'class': 'selector-overlay',
                    "onCreate": function() { console.log('created'); },
                    "onLoaded": function() { console.log('loaded'); },
                    "onDestroy": function() { console.log('Destroyed'); }
                });
            });
        }
    });

    $("body").on("click","i.form-submit" ,function () {
        $(this).parent(".search-input-container").submit();
    })

    $('#newsletter-business').click(function() {
        newsletterChange(true)
    });
    $('#newsletter-private').click(function() {
        newsletterChange(false)
    });

    //show column background images
    $('[data-background-image]').each(function (b, a) {
        $(a).css("background-image", 'url(' + $(a).data('background-image') + "?width=1950&height=250&quality=75&mode=crop&format=jpg" + ')');
        $(a).css("background-repeat", "no-repeat");
        $(a).removeAttr('data-background-image');
    });

}); // Document ready end

function templatePolyfill() {
    if ('content' in document.createElement('template')) {
      return false;
    }
  
    var templates = document.getElementsByTagName('template');
    var plateLen = templates.length;
  
    for (var x = 0; x < plateLen; ++x) {
      var template = templates[x];
      var content = template.childNodes;
      var fragment = document.createDocumentFragment();
  
      while (content[0]) {
        fragment.appendChild(content[0]);
      }
  
      template.content = fragment;
    }
  }

function newsletterChange(isBusiness) {
    if (isBusiness) {
        $('#subFormPrivate').hide();
        $('#subFormBusiness').show();
    } else {
        $('#subFormPrivate').show();
        $('#subFormBusiness').hide();
    }
}

function gridFix(elm) {
    $(elm).each(function () {
        $('.col-md-6:first-child', this).attr('class', 'col-lg-5 col-sm-6')
        $('.col-md-6:last-child', this).attr('class', 'col-lg-5 col-lg-offset-2 col-sm-6')
    });
}

function triggerContact() {
    if ($('#contact-widget').length) {
        var container = $('#contact-widget');
        var expandable = $('.contact-expandable', container);
        var trigger = $('.contact-trigger', container);
        var closeTrigger = $('.contact-trigger, .close', container);
        var triggerInner = $('.inner', trigger);
        var icon = $('i', triggerInner);
        
        var fixWidth = function() {
            if(window.innerWidth > 992){
                triggerInner.css('width', trigger.height());
            }
            else {
                triggerInner.css('width', 'auto');
            }
        };
        // Doc.ready
        setTimeout(function() {
            fixWidth();
            $(window).trigger('resize');
        }, 150);
        // Window.resize
        $(window).resize(function(){ fixWidth(); });

        $(closeTrigger).click(function () {
            $(expandable).toggleClass('active');

            // Change icon
            if($(expandable).hasClass('active')){
                icon.attr('class', 'kosan-icon-close');
            }
            else {
                icon.attr('class', 'kosan-icon-chevron-up');
            }
        });
    }
}

function dynamicContent() {
    if ($('.dynamic-content').length) {

        $('.dynamic-content').each(function() {
            var current = $(this);

            var nav = $('.content-navigation', current);
            var content = $('.content-container', current);

            if($('.active', nav).length) {

                var activeNav = $('.active', nav);
                var activeId = $(activeNav).data('target');

                $('.' + activeId + '', content).addClass('active');
            }

            $('li:not(.disabled)', nav).click(function () {
                var activeNav = $(this);
                var activeId = $(activeNav).data('target');

                $('li', nav).removeClass('active');
                $('.content-page', content).removeClass('active');


                $(activeNav).addClass('active');
                $('.' + activeId + '', content).addClass('active');

            });

        });
    }
}


function FaqChangeUrl(title, url, siteName) {
    if (typeof (history.pushState) != "undefined") {
        var obj = { Title: title, Url: url };
        history.pushState(obj, obj.Title, obj.Url);
        document.title = title + " - " + siteName;
        if (!($(".breadcrumb .current .pagename").text() === "FAQ")) {
            $(".breadcrumb .current .pagename").text(title);
        }
    } else {
        alert("Browser does not support HTML5.");
    }
}

/*
 *  Use the following if needed
 */

// Window resize
$(window).smartresize(function (e) {
    // call functions here
    novicell.responsiveLazyloadImage.onResize();
    novicell.embed.onResize();
}); // Window resize

// Window scroll
$(window).smartscroll(function (e) {
    // call functions here
    if ($('.responsiveLazyload').length > 0) {
        novicell.responsiveLazyloadImage.image();
    }
    if ($('.embed-media-item').length > 0) {
        novicell.embed.loadEmbeds();
    }
    kosan.header.hideMegamenu();
}); // Window scroll

// Window load
// $(window).load(function(e){
//     // call functions here
// }); // Window load

// // Window resize
// $(window).resize(function(e){
//     // call functions here
// }); // Window resize

// // Window scroll
// $(window).scroll(function(e){

// }); // Window scroll